// extracted by mini-css-extract-plugin
export default {"recapTableWrap":"recapTableWrap--uchh6FPZSe","legendWrap":"legendWrap--i9zEOBYlQJ"};